import "./streams.scss";
import Checkbox from "components/controls/checkbox";
import { useCallback, useEffect, useState } from "react";

function Streams({ streamIds, toggleStream, projectTypeId }: { streamIds: number[]; toggleStream: (id: number) => void; projectTypeId: number }) {
    const [allStreamIds, setAllStreamIds] = useState([7, 8, 9, 10, 11]);

    const getStreamName = useCallback((streamId) => {
        switch (streamId) {
            case 7:
                return "x-twitter";
            case 8:
                return "facebook";
            case 9:
                return "instagram";
            case 10:
                return "youtube";
            case 11:
                return "linkedin";
            case 12:
                return "tiktok";
        }
    }, []);

    useEffect(() => {
        if ([5, 6, 7, 9].includes(projectTypeId)) {
            setAllStreamIds([7, 8, 9, 10]);
        }
    }, [projectTypeId]);

    if ([5, 6, 7, 9].includes(projectTypeId)) {
        return (
            <div className="filters-menu-section-body">
                {allStreamIds.map((x) => {
                    return (
                        <div className="input-group" key={x}>
                            <label htmlFor={`stream-${x}`}>
                                <i className={`fab fa-${getStreamName(x)}`}></i>
                            </label>
                            <Checkbox id={`stream-${x}`} checked={streamIds.includes(x)} onChange={() => toggleStream(x)} disabled={streamIds.length === 1 && streamIds.includes(x)} />
                        </div>
                    );
                })}
            </div>
        );
    } else {
        return (
            <div className="filters-menu-section-body">
                <div className="input-group" key={streamIds[0]}>
                    <label htmlFor={`stream-${streamIds[0]}`}>
                        <i className={`fab fa-${getStreamName(streamIds[0])}`}></i>
                    </label>
                    <Checkbox id={`stream-${streamIds[0]}`} checked={true} onChange={() => {}} disabled={true} />
                </div>
            </div>
        );
    }
}

export default Streams;
